import type { PendingWorkOrigin } from '@/services/sync/PendingSyncSession';

export const DEFERRED_MEDIA_CLEANUP_TABLE = 'deferred_media_cleanup';

/** Evidência local de sucessão. Nunca constitui autorização para apagar bytes. */
export function planDeferredMediaCleanup(input: {
  id?: string;
  origin: PendingWorkOrigin | null;
  fieldId: string;
  previous: Record<string, any> | null;
  next: Record<string, any>;
  supersededUploads: Record<string, any>[];
  successor?: Record<string, any> | null;
}) {
  const { id, origin, fieldId, previous, next, supersededUploads } = input;
  if ((!previous?.valor || previous.valor === next.valor) && supersededUploads.length === 0) return null;
  if (!id || !origin || next.empresa_id !== origin.empresaId) throw new Error('cleanup_origin_required');
  if (supersededUploads.some(row => row.user_id !== origin.userId || row.empresa_id !== origin.empresaId)) {
    throw new Error('cleanup_upload_origin_mismatch');
  }
  return {
    id: `media:${id}`, user_id: origin.userId, empresa_id: origin.empresaId,
    checklist_id: next.checklist_id, field_id: fieldId,
    payload: JSON.stringify({ schema_version: 1, state: 'deferred', physical_deletion_allowed: false,
      previous, next, supersededUploads, successor: input.successor ?? null }),
    created_at: Date.now(),
  };
}

export function assertSameCleanupIntent(previous: Record<string, any> | undefined | null, next: Record<string, any>) {
  if (previous && ['user_id', 'empresa_id', 'checklist_id', 'field_id', 'payload'].some(key => previous[key] !== next[key])) {
    throw new Error('cleanup_idempotency_mismatch');
  }
}

/** O original local permanece rastreável depois que o upload sai da fila ativa. */
export function retainAcknowledgedLocalMedia(pending: Record<string, any>, value: Record<string, any>, publicUrl: string) {
  return { id: `ack:${pending.id}`, user_id: pending.user_id ?? 'unknown', empresa_id: value.empresa_id,
    checklist_id: pending.item_id, field_id: pending.campo_id, created_at: Date.now(),
    payload: JSON.stringify({ schema_version: 1, kind: 'acknowledged-local-media', state: 'retained',
      physical_deletion_allowed: false, originalAuthor: pending.user_id ?? null, pending, value, publicUrl }) };
}
